import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = (props) => {
  const [show, setShow] = useState(false);
  const { className = "", ...rest } = props;
  return (
    <div className="relative">
      <Input {...rest} type={show ? "text" : "password"} className={`${className} pr-12`} />
      <button
        type="button"
        data-testid={`${props["data-testid"]}-toggle`}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
        aria-label={show ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
